function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.43 14.333H10.3v-1h3.802L13.5 11.5h-2.869c-.861.822-1.657 1.577-2.37 2.555L7.5 15.097l-.76-1.042c-.72-.987-1.534-1.756-2.37-2.555H1.5l-.602 1.833H4.7v1H.57L0 16.067h15l-.57-1.734z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 13.5c2.27-3.11 5.5-4.31 5.5-8C13 2.348 10.652 0 7.5 0 4.35 0 2 2.348 2 5.5c0 3.689 3.232 4.89 5.5 8zm0-9.293c.826 0 1.5.673 1.5 1.5 0 .826-.674 1.5-1.5 1.5S6 6.533 6 5.707c0-.827.674-1.5 1.5-1.5z",
  fill: "#fff"
});

function SvgIconGeneralInfoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconGeneralInfoSmall;